"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatingDots = exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const deepmerge_1 = __importDefault(require("deepmerge"));
const styled_components_1 = __importStar(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const visually_hidden_1 = __importDefault(require("@reach/visually-hidden"));
const Element_1 = require("../Element");
const variantStyles = {
    primary: {
        backgroundColor: 'button.background',
        color: 'button.foreground',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            // hoverBackground is polyfilled and uses a gradient
            // so we use background and not backgroundColor
            // background is not hooked to the system like backgroundColor
            // so we need to write the long syntax
            // TODO @sid: extend our system to make background work as well
            background: theme => theme.colors.button.hoverBackground,
        },
    },
    secondary: {
        backgroundColor: '#ffffff1a',
        color: '#F2F2F2',
        ':hover:not(:disabled)': {
            background: '#333333',
        },
    },
    link: {
        backgroundColor: 'transparent',
        color: '#dbdbdb',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            color: 'foreground',
            backgroundColor: '#E5E5E51A',
        },
    },
    ghost: {
        backgroundColor: 'transparent',
        color: '#dbdbdb',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            color: 'foreground',
            backgroundColor: '#FFFFFF1A',
        },
    },
    danger: {
        backgroundColor: 'dangerButton.background',
        color: 'dangerButton.foreground',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            background: theme => theme.colors.dangerButton.hoverBackground,
        },
    },
    light: {
        backgroundColor: '#FFFFFF',
        color: '#0E0E0E',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            backgroundColor: '#E0E0E0', // three up in the gray scale (gray[400])
        },
    },
    dark: {
        backgroundColor: '#0E0E0E',
        color: '#FFFFFF',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            backgroundColor: '#252525', // three down in the black scale (black[500])
        },
    },
    trial: {
        backgroundColor: '#644ED7',
        color: '#FFFFFF',
        ':hover:not(:disabled), :focus:not(:disabled)': {
            backgroundColor: '#7B61FF',
        },
    },
};
const sizeStyles = {
    regular: {
        paddingY: '4px',
        paddingX: '8px',
        height: '28px',
        fontSize: '13px',
        fontWeight: 'medium',
        lineHeight: '16px', // trust the height
    },
    large: {
        height: 'auto',
        paddingY: '12px',
        paddingX: '16px',
        fontWeight: 500,
        fontSize: '16px',
        whiteSpace: 'nowrap',
    },
};
const commonStyles = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 'none',
    fontFamily: 'Inter, sans-serif',
    width: '100%',
    border: 'none',
    borderRadius: '4px',
    transition: 'background .3s, color .3s, box-shadow .3s',
    textDecoration: 'none',
    ':focus-visible': {
        boxShadow: `0 0 0 2px #AC9CFF`,
        outline: 'none',
    },
    ':active:not(:disabled)': {
        transform: 'scale(0.98)',
    },
    ':disabled': {
        opacity: '0.4',
        cursor: 'not-allowed',
    },
    '&[data-loading="true"]': {
        opacity: 1,
        cursor: 'default',
    },
    '&[data-auto-width="true"]': {
        width: 'fit-content',
    },
};
exports.Button = react_1.default.forwardRef(function Button(_a, ref) {
    var { variant = 'primary', size = 'regular', loading, css = {}, autoWidth, as: pAs } = _a, props = __rest(_a, ["variant", "size", "loading", "css", "autoWidth", "as"]);
    const styles = deepmerge_1.default.all([
        variantStyles[variant],
        sizeStyles[size],
        commonStyles,
        css,
    ]);
    const usedAs = pAs || (props.to ? react_router_dom_1.Link : 'button');
    // default type is button unless props.as was changed
    const type = usedAs === 'button' && 'button';
    return (react_1.default.createElement(Element_1.Element, Object.assign({ as: usedAs, type: type, css: styles, ref: ref, disabled: props.disabled || loading, "data-loading": loading, "data-auto-width": autoWidth }, props), loading ? react_1.default.createElement(exports.AnimatingDots, null) : props.children));
});
/** Animation dots, we use the styled.span syntax
 *  because keyframes aren't supported in the object syntax
 */
const transition = (0, styled_components_1.keyframes)({
    '0%': { opacity: 0.6 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0.6 },
});
const Dot = styled_components_1.default.span `
  font-size: 18px;
  animation: ${transition} 1.5s ease-out infinite;
`;
const AnimatingDots = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(visually_hidden_1.default, null, "Loading"),
    react_1.default.createElement("span", { role: "presentation" },
        react_1.default.createElement(Dot, null, "\u00B7"),
        react_1.default.createElement(Dot, { style: { animationDelay: '200ms' } }, "\u00B7"),
        react_1.default.createElement(Dot, { style: { animationDelay: '400ms' } }, "\u00B7"))));
exports.AnimatingDots = AnimatingDots;
